import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";
import "bootstrap";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

var carouselElem = document.querySelector(".main-carousel");
if (carouselElem) {
  var flkty = new Flickity(carouselElem, {
    cellAlign: "left",
    contain: true,
    groupCells: 2,
  });
}
const openBtn = document.getElementById("open-video");
const modal = document.getElementById("video-modal");
const closeOverlay = document.getElementById("close-modal");
const closeBtn = document.getElementById("close-btn");
const video = document.getElementById("cv-video");

openBtn.addEventListener("click", () => {
  modal.classList.add("is-open");
});

function closeModal() {
  modal.classList.remove("is-open");
  video.pause();
}

closeOverlay.addEventListener("click", closeModal);
closeBtn.addEventListener("click", closeModal);

const openCvBtn = document.getElementById("open-cv");
const cvModal = document.getElementById("cv-modal");
const closeCvOverlay = document.getElementById("close-cv-modal");
const closeCvBtn = document.getElementById("close-cv-btn");

if (openCvBtn) {
  openCvBtn.addEventListener("click", () => cvModal.classList.add("is-open"));
}
if (closeCvOverlay) {
  closeCvOverlay.addEventListener("click", () =>
    cvModal.classList.remove("is-open")
  );
}
if (closeCvBtn) {
  closeCvBtn.addEventListener("click", () =>
    cvModal.classList.remove("is-open")
  );
}
